<template>
  <div
    class="main"
    style="display: flex; flex-wrap: wrap;gap:20px;"
  >
    <div style="flex: 1;">
      <div class="toolbar">
        <div
          class="toolbar__row"
        >
          <span class="m-0 me-3">{{ $t('Category') }}</span>
          <div class="search-filter search-filter--super-narrow">
            <b-icon-search />
            <input
              v-model="filterCategory"
              type="text"
              autocomplete="off"
              name="search-box"
              :placeholder="$t('Search')"
            >
          </div>
          <div
            style="width: 63%;"
            class="d-flex justify-content-end align-items-center"
          >
            <button
              v-b-modal.modal-add-category
              class="button"
            >
              {{ $t('AddCategory') }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <table
          class="team_table"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>{{ $t('CategoryName') }}</th>
              <th class="text-end pe-5">
                {{ $t('Edit') }}
              </th>
            </tr>
          </thead>
          <LoadingSpinnerTable
          :is-loading="isRequestLoading('dressCategories')"
          :responseData="filteredCategorys"
          >
            <tr
              v-for="(category, index) in filteredCategorys"
              :key="index"
            >
              <td>{{ category.name }}</td>
              <td
                v-b-modal.modal-edit-category
                class="text-end"
                @click="editProdCategory(category)"
              >
                <b-icon-pencil class="me-5 pe-3" />
              </td>
            </tr>
          </LoadingSpinnerTable>
        </table>
      </div>
      <AddCategory @addCategory="addCategories" />
      <EditCategory
        :category="category"
        @updateCategory="editCategories"
      />
    </div>

    <div style="flex: 1;">
      <div class="toolbar">
        <div class="toolbar__row">
          <span class="m-0 me-3">{{ $t('Size') }}</span>
          <div class="search-filter search-filter--super-narrow">
            <b-icon-search />
            <input
              v-model="filterSize"
              :placeholder="$t('Search')"
            >
          </div>
          <div
            style="width: 69%;"
            class="d-flex justify-content-end align-items-center"
          >
            <button
              v-b-modal.modal-add-lov-size
              class="button"
            >
              {{ $t('AddSize') }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <table
          class="team_table"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>{{ $t('SizeName') }}</th>
              <th class="text-end pe-5">
                {{ $t('Edit') }}
              </th>
            </tr>
          </thead>
          <LoadingSpinnerTable
          :is-loading="isRequestLoading('productSizes')"
          :responseData="filteredSizes"
          >
            <tr
              v-for="(size, index) in filteredSizes"
              :key="index"
            >
              <td>{{ size.name }}</td>
              <td
                v-b-modal.modal-edit-luv-size
                class="text-end"
                @click="editProdSize(size)"
              >
                <b-icon-pencil class="me-5 pe-3" />
              </td>
            </tr>
          </LoadingSpinnerTable>
        </table>
      </div>
      <AddLovSize @addSize="addSizes" />
      <EditLovSize
        :size="size"
        @updateSize="editSize"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AddCategory from '@/components/products/modals/AddCategory.vue'
import AddLovSize from '@/components/products/modals/AddLovSize.vue'
import EditCategory from '@/components/products/modals/EditCategory.vue'
import EditLovSize from '@/components/products/modals/EditLovSize.vue'

export default {
  components: {
    AddCategory,
    AddLovSize,
    EditCategory,
    EditLovSize,
  },
  data() {
    return {
      filterSize: '',
      filterCategory: '',
      category: {
        name: null,
        lovDressCategoryId: null,
      },
      size: {
        name: null,
        sizeDataId: null,
      },
    }
  },
  computed: {
    ...mapGetters(['getDressCategory', 'getProductSize']),
    filteredSizes() {
      return this.getProductSize.filter((size) => { return size.name.toLowerCase().startsWith(this.filterSize.toLowerCase()) });
    },
    filteredCategorys() {
      return this.getDressCategory.filter((size) => { return size.name.toLowerCase().startsWith(this.filterCategory.toLowerCase()) });
    },
  },
  mounted() {
    this.dressCategories()
    this.productSizes()
  },
  methods: {
    ...mapActions(['editLuvSize', 'editCategory', 'dressCategories', 'productSizes', 'addProductCategory', 'addProductLovSize']),
    async addCategories(obj) {
      await this.addProductCategory({
        object: obj,
        successCallback: () => {
          this.dressCategories()
        },
      })
    },
    async addSizes(obj) {
      await this.addProductLovSize({
        object: obj,
        successCallback: () => {
          this.productSizes()
        },
      })
    },
    async editCategories(obj) {
      await this.editCategory({
        object: obj,
        successCallback: () => {
          this.dressCategories()
        },
      })
    },
    async editSize(obj) {
      await this.editLuvSize({
        object: obj,
        successCallback: () => {
          this.productSizes()
        },
      })
    },
    editProdCategory(category) {
      this.category.name = category.name;
      this.category.lovDressCategoryId = category.lovDressCategoryId;
      this.$bvModal.show('modal-edit-category');
    },
    editProdSize(size) {
      this.size.name = size.name;
      this.size.sizeDataId = size.sizeDataId;
      this.$bvModal.show('modal-edit-luv-size');
    },
  },
}
</script>

<style>
.team_table td {
  padding: 16px 9px !important;
}
</style>
